<template>
  <div>
    <!-- Top navbar -->
    <nav class="navbar navbar-top navbar-expand-md bg-white shadow border-bottom" id="navbar-main">
      <div class="container-fluid">
        <!-- Brand -->
        <router-link :to="{name: 'manageAddressBook'}" class="h4 mb-0 text-uppercase d-none d-lg-inline-block">
          Manage Address Book
        </router-link>
        <user-data></user-data>
        
      </div>
    </nav>
    <!-- Page content -->
    <div class="container-fluid mt-0 pt-5 pt-md-8">
      <div class="row mb-5 mb-xl-0">
        <div class="col-md-3">
          <b-form-group label="Site" label-for="session">
            <b-form-select id="session" @input="getAddressBook(form), getMeterList()"
              v-model="form.siteId" class="form-control-alternative">
              <option value='null' class="bg-grey text-white" disabled selected>Please select Site</option>
              <option v-for="list in coPropList.data" :key="list.id" v-bind:value='list.id'>{{list.name}}</option>
            </b-form-select>
          </b-form-group>
        </div>
        <!-- <div class="col-md-3"> 
          <b-form-group label="Meter Type" label-for="session">
            <b-form-select id="session" @input="getAddressBook(form)"
              v-model="form.serviceId" class="form-control-alternative">
              <option value='null' class="bg-grey text-white" disabled selected>Please select Meter</option>
              <option v-for="list in meterList"  :key="list.id" v-bind:value='list.id'>{{list.service_name}}</option>
            </b-form-select>
          </b-form-group>
        </div> -->
      </div>
      <div class="row mt-4"  v-if="form.siteId != null">
        <div class="col-md-12 mb-5 mb-xl-0">
          <div class="card shadow mb-5">
            <div class="card-header border-0">
              <div class="row align-items-center">
                <div class="col">
                  <h3 class="mb-0">Address Book Lists</h3>
                </div>
                <div class="col">
                  <b-input-group size="sm">
                    <b-form-input @input.native="noSearchData" v-model="form.search" placeholder="Enter Lot No."/>
                    <b-input-group-append>
                      <b-btn size="sm" text="Button" @click="getAddressBook(form)" variant="success">Search</b-btn>
                    </b-input-group-append>
                  </b-input-group>
                </div>
              </div>
            </div>
            <div class="table-responsive" v-if="pagination.total != 0">
              <b-table class="mt-3" striped hover :items="addressList.data" :fields="fields">
                <template slot="lot_no" slot-scope="data">
                  {{data.item.lot_owner.lot_no}}
                </template>
                <template slot="account_code" slot-scope="data">
                  {{data.item.lot_owner.account_code}}
                </template>
                <template slot="name" slot-scope="data">
                  {{data.item.lot_owner.name}}
                </template>
                <template slot="vilogiAdherent" slot-scope="data">
                  <span v-if="!data.item.lot_owner || !data.item.lot_owner.account_code"
                    class="text-danger" v-b-tooltip.hover="'No account code set — required before Vilogi can match this owner'">
                    <i class="fas fa-exclamation-triangle mr-1"></i>No Account number
                  </span>
                  <span v-else-if="data.item.lot_owner.vilogi_adherent_id == null"
                    class="text-danger" v-b-tooltip.hover="'This account code did not match any Vilogi account — check it for typos'">
                    <i class="fas fa-exclamation-triangle mr-1"></i>Invalid account number
                  </span>
                  <span v-else class="text-success" v-b-tooltip.hover="'Linked to a Vilogi account'">
                    <i class="fas fa-check-circle"></i>
                  </span>
                </template>
                <template slot="email" slot-scope="data">
                  {{data.item.lot_owner.email}}
                </template>
                <template slot="meter_id" slot-scope="data">
                  {{data.item.barcode.data.meter_id}}
                </template>
                <template slot="barcode" slot-scope="data">
                  {{data.item.barcode.data.barcode}}
                </template>
                <template slot="serviceType" slot-scope="data">
                  {{data.item.service_type.service_name}}
                </template>
                <template slot="actions" slot-scope="data">
                  <b-link @click='editAddress(data.item)' class="text-primary"><i class="far fa-edit mr-2"></i></b-link>
                </template>
              </b-table>
              <div class="card-footer border-0 my-2" v-if="pagination.total != 0">
                <b-pagination align="right" @input="pageClick(currentPage)" :total-rows="pagination.total" v-model="currentPage" :per-page="10">
                </b-pagination>
              </div>
            </div>
            <div v-show="pagination.total == 0">
              <h4 class="py-5 text-center">No records available</h4>
            </div>
          </div>
        </div>
      </div>
      <div class="row my-4" v-if="form.siteId == null">
        <div class="col-md-12 mb-5 mb-xl-0">
          <div class="card shadow mb-5">
            <div class="row m-0 px-2 pb-4">
              <div class="col-md-12">
                <h4 class="py-5 my-3 text-center"> Please select co props and meter type</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Add rate modal -->
      <b-modal no-close-on-backdrop no-close-on-esc centered size="lg" hide-footer ref="editAddress" id="editAddress" 
        title="Edit Address Book" :hide-header-close="true">
        <b-form @submit.prevent="updateAddress(editData)">
          <div class="row m-0">
            <b-form-group id="lotNo" label="Lot No" label-for="lotNo" class="col-md-2">
              <b-form-input id="lotNo" readonly type="text" v-model="editData.lot_no" placeholder="Enter lot number">
              </b-form-input>
            </b-form-group>
            <b-form-group id="name" label="Name" label-for="name" class="col-md-5">
              <b-form-input id="name" type="text" v-model="editData.name" placeholder="Enter name">
              </b-form-input>
            </b-form-group>
            <b-form-group id="email" label="Email" label-for="email" class="col-md-5">
              <b-form-input id="email" type="email" v-model="editData.email" placeholder="Enter email">
              </b-form-input>
            </b-form-group>
            <b-form-group id="alternateemail1" label="Alternate Email1" label-for="alternateemail1" class="col-md-5">
              <b-form-input id="alternateemail1" type="email" v-model="editData.alternate_email_1" placeholder="Enter alternate email1">
              </b-form-input>
            </b-form-group>
            <b-form-group id="alternateemail2" label="Alternate Email2" label-for="alternateemail2" class="col-md-5">
              <b-form-input id="alternateemail2" type="email" v-model="editData.alternate_email_2" placeholder="Enter alternate email2">
              </b-form-input>
            </b-form-group>
            <b-form-group id="account_code" label="Account Code" label-for="account_code" class="col-md-5">
              <b-form-input id="account_code" type="text" v-model="editData.account_code" placeholder="Enter account code">
              </b-form-input>
            </b-form-group>
            <b-form-group id="vilogiAdherentId" label="Vilogi Adherent ID" label-for="vilogiAdherentId" class="col-md-2">
              <b-form-input id="vilogiAdherentId" readonly type="text"
                :value="editData.vilogi_adherent_id != null ? editData.vilogi_adherent_id : 'Not linked'">
              </b-form-input>
            </b-form-group>
            <b-form-group id="address" label="Address" label-for="address" class="col-md-12">
              <b-form-textarea id="address" type="text" v-model="editData.address" placeholder="Enter address">
              </b-form-textarea>
            </b-form-group>
          </div>
          <div class="row m-0">
            <div class="col-md-12 text-right">
              <b-link @click="hideModal">Cancel</b-link>
              <b-button type="submit" variant="success" class="ml-3">Submit</b-button>
            </div>
          </div>
        </b-form> 
      </b-modal>
    </div>
    {{getData}}
  </div>
</template>
<script>
  import { mapGetters, mapActions } from 'vuex'
  import userData from '@/pages/Common/userData';

  export default {
    components: {
      userData
    },
    data () {
      return {
        pagination: {},
        currentPage: 1,
        form : {
          siteId: null,
          serviceId: null,
          page: 1,
          search: ''
        },
        editData:{},
        baseFields: [
          {
            key: 'lot_no',
            label: 'Lot No',
            sortable: true,
            'class': 'text-center'
          },
          {
            key: 'account_code',
            label: 'Acc Code',
            sortable: true,
            'class': 'text-center'
          },
          {
            key: 'name',
            label: 'Owner',
            sortable: true,
            'class': 'text-center'
          },
          {
            key: 'serviceType',
            label: 'Service Type',
            sortable: true,
            'class': 'text-center'
          },
          {
            key: 'email',
            label: 'Email Address',
            sortable: true,
            'class': 'text-center'
          },
          {
            key: 'meter_id',
            label: 'Meter Id',
            sortable: true,
            'class': 'text-center'
          },
          {
            key: 'barcode',
            label: 'Barcode',
            sortable: true,
            'class': 'text-center'
          },
          {
            key: 'actions',
            label: 'Actions',
            sortable: false,
            'class': 'text-center'
          },
        ],
      }
    },
    computed: {
      ...mapGetters('coprops', ['coPropList', 'meterList', 'addressList', 'addressListVilogiActivated']),
      fields() {
        if (!this.addressListVilogiActivated) return this.baseFields
        const vilogiField = { key: 'vilogiAdherent', label: 'Vilogi', sortable: false, 'class': 'text-center' }
        const nameIndex = this.baseFields.findIndex(f => f.key === 'name')
        const withVilogi = [...this.baseFields]
        withVilogi.splice(nameIndex + 1, 0, vilogiField)
        return withVilogi
      },
      getData() {
        // console.log(this.coPropList, "===coPropList")
        // console.log(this.meterList, "===meterList")
        // console.log(this.addressList.data[0].barcode.data.barcode, "===addressList")

      }
    },
    methods: {
      ...mapActions('coprops', ['ALL_CO_PROP_LIST', 'ALL_METER_LIST', 'ALL_ADDRESS_BOOK', 'UPDATE_ADDRESS_BOOK']),
      getCoPropList () {
        // Get all site list
        this.ALL_CO_PROP_LIST().then(()=>{
        }).catch(() => {
        });
        // Get all Meter list
        // this.ALL_METER_LIST().then(()=>{
        // }).catch(() => {
        // })
      },
      getMeterList () {
        let meterListDetails = {
          site_id: this.form.siteId
        }
        this.ALL_METER_LIST(meterListDetails).then(()=>{
        }).catch(() => {
        })
      },
      getAddressBook (data) {
        if(data.siteId == '') {
          this.ERROR_TOAST_MSG('Please select site');
        } else if(data.serviceId == '') {
          this.ERROR_TOAST_MSG('Please select meter type');
        } else {
          let payload = {
            site_id: data.siteId,
            service_type_id:data.serviceId,
            page: data.page,
            search: data.search
          }
          this.ALL_ADDRESS_BOOK(payload).then(()=>{
            this.pagination = this.addressList.meta.pagination;
          }).catch(() => {
          });

        }
      },
      noSearchData () {
        if (this.form.search == '') {
          this.getAddressBook(this.form)
        }
      },
      pageClick (data) {
        this.form.page = data
        this.getAddressBook(this.form);
      },
      editAddress (data) {
        console.log(data)
        this.editData = {
          lot_id: data.id,
          lot_owner_id: data.lot_owner.id,
          lot_no: data.lot_owner.lot_no,
          name: data.lot_owner.name,
          address: data.lot_owner.address,
          account_code: data.lot_owner.account_code,
          vilogi_adherent_id: data.lot_owner.vilogi_adherent_id,
          email: data.lot_owner.email,
          alternate_email_1: data.lot_owner.alternate_email_1,
          alternate_email_2: data.lot_owner.alternate_email_2
        }
        this.$refs.editAddress.show()
      },
      updateAddress(data) {
        if (!data.name) {
          this.ERROR_TOAST_MSG('Please enter the name')
        } else if (!data.email) {
          this.ERROR_TOAST_MSG('Please enter the email')
        } else {
          this.UPDATE_ADDRESS_BOOK(data).then(()=>{
            this.getAddressBook(this.form);
            this.$refs.editAddress.hide()
          }).catch(() => {
          });
        }
      },
      hideModal() {
        this.$refs.editAddress.hide()
      },
    },
    created () {
      if (!localStorage.token) {
        localStorage.clear()
        next({
          name: 'adminLogin'
        })
      } else {
        if(localStorage.roleId == 1){
          this.$router.replace({name: "dashboard"});
        }

        this.getCoPropList();
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Admin/manageAddressBook.vue